'use strict';

/**
 * Clase que maneja el comportamiento del slider Hero.
 */
class HeroSlideshow {
  /**
   * Crea una instancia del slider.
   * @param {HTMLElement} element - Elemento contenedor del slider.
   */
  constructor(element) {
    this.element = element;
    this.swiper = null; // Instancia de Swiper
    this.init();

    // Escucha el evento de selección de bloque en Shopify y cambia el slide activo.
    window.addEventListener('shopify:block:select', (e) => {
      const selectedSlideIndex = +e.target.dataset.index;
      if (this.swiper) {
        this.swiper.slideTo(selectedSlideIndex, 600);
      }
    });
  }

  /**
   * Inicializa el slider al cargarse el DOM.
   */
  init() {
    // Se utiliza DOMContentLoaded para iniciar el slider tan pronto como el DOM esté listo.
    this.mountSlider();
  }

  /**
   * Configura e inicializa el slider utilizando Swiper.
   */
  mountSlider() {
    const swiperContainer = this.element;
    const {
      speed: dataSpeed,
      interval: dataInterval,
      autoplay: dataAutoplay,
      effect: dataEffect,
    } = swiperContainer.dataset;

    const speed = dataSpeed ? parseInt(dataSpeed, 10) : 50;
    const interval = dataInterval ? parseInt(dataInterval, 10) : 2000;
    const autoplay = dataAutoplay === 'true';
    const effect = dataEffect || 'fade';

    // Configuración base para Swiper
    const swiperConfig = {
      spaceBetween: 0,
      rewind: false,
      loop: true,
      effect,
      speed,
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };

    // Si el autoplay está habilitado, se añade la configuración correspondiente.
    if (autoplay) {
      swiperConfig.autoplay = {
        delay: interval,
        disableOnInteraction: false,
      };
    }

    // Inicialización del slider con la configuración definida.
    this.swiper = new Swiper(swiperContainer, swiperConfig);
  }
}

// Espera a que el DOM esté listo para inicializar todos los sliders.
document.addEventListener('DOMContentLoaded', () => {
  const swipers = document.querySelectorAll('div.mySwiper');
  swipers.forEach((swiper) => new HeroSlideshow(swiper));
});
